import { type ReactElement } from 'react'
import { PermissionContent, RoleInfo, TDrawer, TListItem } from '@components'
import { useRoles, useTranslation } from '@front/model'
import { Group, Stack } from '@mantine/core'
import { isDefined } from '@terros/common'
import { parseAsRoleId } from '@util'
import { useQueryState } from 'nuqs'

export const RolePermissions = (): ReactElement => {
  const { data: roles } = useRoles()
  const { t } = useTranslation()
  const [roleId, setRoleId] = useQueryState('roleId', parseAsRoleId)

  return (
    <Stack>
      {roles?.map((role) => (
        <TListItem key={role.roleId} leftSection={role.name} onClick={() => setRoleId(role.roleId)} />
      ))}
      <TDrawer
        opened={isDefined(roleId)}
        size='xl'
        title={
          <Group>
            {t('Permissions for all users with the role:')} {roleId && <RoleInfo roleId={roleId} />}
          </Group>
        }
        onClose={() => setRoleId(null)}
      >
        {roleId && <PermissionContent entityId={roleId} />}
      </TDrawer>
    </Stack>
  )
}
